var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeletefile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.8H13.3C13.6866 2.8 14 3.1134 14 3.5C14 3.8866 13.6866 4.2 13.3 4.2H12.6V13.3C12.6 13.4857 12.5263 13.6637 12.395 13.795C12.2637 13.9263 12.0857 14 11.9 14H2.1C1.91435 14 1.7363 13.9263 1.60503 13.795C1.47375 13.6637 1.4 13.4857 1.4 13.3V4.2H0.7C0.3134 4.2 0 3.8866 0 3.5C0 3.1134 0.313401 2.8 0.7 2.8H3.5V0.7C3.5 0.514348 3.57375 0.336301 3.70503 0.205025C3.8363 0.0737498 4.01435 0 4.2 0H9.8C9.98565 0 10.1637 0.0737498 10.295 0.205025C10.4263 0.336301 10.5 0.514348 10.5 0.7V2.8ZM11.2 4.2H2.8V12.6H11.2V4.2ZM4.9 1.4V2.8H9.1V1.4H4.9Z",
    fill: "#D70102"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletefile);
export default __webpack_public_path__ + "static/media/deletefile.5881d13851a98177a459e962bce114ad.svg";
export { ForwardRef as ReactComponent };